import { uniqueId } from 'lodash';
import { emptyDatiqUnavButton } from './datiq-unav-button-empty.model';
import { emptyDatiqUnavLink } from './datiq-unav-link-model-empty';
import { emptyDatiqUnavPanel } from './datiq-unav-panel-model-empty';
import {
    IDatiqUnav,
    IDatiqUnavItem
} from './datiq-unav.interface';

const DATIQ_DEFAULT_ARRAY: unknown[] = [];
const DATIQ_DEFAULT_BOOLEAN = false;
const DATIQ_DEFAULT_ID: () => string = () => `link-${uniqueId()}`;

export const DATIQ_UNAV = 'datiq-unav';
export const DATIQ_UNAV_USURP_MODAL_ID = `datiq-usurp-modal`;
export const DATIQ_UNAV_DEFAULT_PROFILE_DRAWER_TITLE = 'Account';

export const DATIQ_UNAV_UPSELL_ICON = 'app:upsell-icon';

export const emptyDatiqUnavItem: IDatiqUnavItem = {
    link: { ...emptyDatiqUnavLink },
    panel: { ...emptyDatiqUnavPanel },
    button: { ...emptyDatiqUnavButton },
    isLink: DATIQ_DEFAULT_BOOLEAN,
    isPanel: DATIQ_DEFAULT_BOOLEAN,
    isButton: DATIQ_DEFAULT_BOOLEAN,
};

export const emptyDatiqUnav: IDatiqUnav = {
    id: DATIQ_DEFAULT_ID(),
    items: DATIQ_DEFAULT_ARRAY as IDatiqUnavItem[],
    userLinks: DATIQ_DEFAULT_ARRAY as IDatiqUnavItem[],
    versionNum: '0.1.2',
    loaded: DATIQ_DEFAULT_BOOLEAN,
    noAccess: DATIQ_DEFAULT_BOOLEAN,
    drawerTitle: DATIQ_UNAV_DEFAULT_PROFILE_DRAWER_TITLE,
};
